import Switch from '@repo/ui/switch'
import { useMutation } from '@tanstack/react-query'
import { useEffect, useState } from 'react'

import { updateRadAffectedStaff } from '../../../api/rads/update-rad-affected-staff'
import { UpdateRadParticipantInput } from '../../../lib/types/models/rad/update-rad-affected-staff'
import { showAxiosError } from '../../../lib/utils/functions/misc.functions'

type Props = {
  participantId: number
  radId: number
  name: keyof Pick<UpdateRadParticipantInput, 'partcipatedInRad' | 'wasAbsentToRad'>
  checked?: boolean
  onSuccess?: () => void
}

const UpdateRadSwitch = ({ participantId, radId, name, checked = false, onSuccess }: Props) => {
  const [value, setValue] = useState<boolean>(!!checked)

  useEffect(() => {
    setValue(!!checked)
  }, [checked])

  const { mutate, isPending } = useMutation({
    mutationFn: updateRadAffectedStaff,
    onError: (error) => {
      // revert on error
      setValue((prev) => !prev)
      showAxiosError(error)
    },
    // ensure parent can sync data source to avoid flicker/inversion on re-render
    onSuccess
  })

  const onCheckedChange = (next: boolean) => {
    if (radId) {
      // optimistic update
      setValue(next)
      mutate({ id: radId, participantId, [name]: next })
    }
  }

  return (
    <Switch checked={value} disabled={!radId || isPending} onCheckedChange={onCheckedChange} />
  )
}

export default UpdateRadSwitch
